<template>
  <v-app :dark="isDark" :class="{ 'dark-mode': isDark }">
    <v-container>
    <v-card :dark="isDark" :class="{ 'dark-mode': isDark }">
      <v-card-title>104 000 ₸</v-card-title>
      <v-card-subtitle class="task-description">Доступно из зарплаты 400 000₸ </v-card-subtitle>
      <v-card-actions class="pa-2">
        <v-btn
            large
            color="#1751D0"
            class="ma-0"
            style="width: 100%; border-radius: 12px"
            @click="openRequest"
        >
          Запросить аванс
        </v-btn>
      </v-card-actions>
    </v-card>
  <div>
    <v-tabs class="custom-tabs" :dark="isDark" v-model="activeTab" fixed-tabs>
      <v-tab>
        Активные
      </v-tab>
      <v-tab>История</v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab" class="tab-items">
      <v-tab-item>
        <div v-if="request" >
          <div v-for="(r, i) in request" :key="i" class="request-item">
            <div class="request-item-header">
              <h4 class='request-item-header-text'>{{r.amount}}</h4>
              <p class='request-item-header-text'>{{r.date}}</p>
            </div>
            <p class='request-item-header-text'>Заявка обрабатывается</p>
          </div>
        </div>
        <div class="count-item" v-else>
          <span class="card-text">У вас пока нет активных заявок</span>
        </div>
      </v-tab-item>
      <v-tab-item >
        <div class="count-item">
          <span class="card-text">У вас пока истории заявок</span>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
    <h2>Как мы считаем</h2>
    <v-list :dark="isDark">
      <v-list-item v-for="(item, i) in listItems" :key="i">
        <v-list-item-icon>
          <v-icon v-text="item.icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle v-text="item.title"></v-list-item-subtitle>
          <v-list-item-title v-text="item.subtitle"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    </v-container>
  </v-app>
</template>

<script>
import {storage} from "@orta/bridge";

export default {
  data() {
    return {
      currentTask: null,
      theme: 'light',
      activeTab: 0,
      listItems: [
        {title: 'Размер зарплаты', subtitle: '111 000 ₸', icon: 'mdi-credit-card-plus'},
        {title: 'Из 22 рабочих дней', subtitle: '15 дней отработано', icon: 'mdi-calendar-multiselect'},
        {title: 'Стоимость рабочего дня', subtitle: '4 321,23 ₸', icon: 'mdi-cash-multiple'},
        {title: 'Формула вычисления', subtitle: '111 000 ₸  * 15 = 115 000 ₸', icon: 'mdi-poll'},
      ],
      request: null,
    };
  },
  computed: {
    isBridgeAvailable() {
      return require('@orta/bridge').isWebViewBridgeAvailable()
    },
    isDark() {
      return this.theme === 'dark';
    },
  },
  created() {
    this.theme = this.$route.query.theme || localStorage.getItem('theme') || 'light';
  },
  mounted() {
    if (this.isBridgeAvailable) {
      require('@orta/bridge').setTitle('Запрос аванса');
      require('@orta/bridge').backArrow.setMode(true);
      require('@orta/bridge').backArrow.setVisible(true);
      require('@orta/bridge').backArrow.setOnClickHandler(this.goBack);
      this.loadStoredData()
    }
  },
  methods: {
    goBack() {
      this.$router.replace({name: 'HomeView' });
    },
    openRequest() {
      this.$router.push({ name: 'AdvanceRequestPage' });
    },
    async loadStoredData() {
      try {
        const storedRequests = await storage.getItem('requests');
        console.log(storedRequests);
        this.request = JSON.parse(storedRequests);
      } catch (error) {
        console.log(error);
      }
    },
  }
}
</script>

<style scoped>
.card-text {
  text-align: center;
  padding: 24px;
  color: var(--text-color);
}

h2 {
  color: var(--text-color);
}

.custom-tabs {
  color: var(--text-color) !important;
}

.task-description {
  color: var(--text-color);
  line-height: 1.5;
  font-size: 16px;
}

.count-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  background: var(--bg-color-secondary);
}

.request-item {
  background-color: var(--bg-color-secondary);
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 16px;
}

.request-item-header {
  display: flex;
  justify-content: space-between;
}

.request-item-header-text {
  color: var(--text-color);
}

.tab-items {
  background-color: var(--bg-color-secondary);
  border-width: 0;
}
</style>
